"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var tabs_1 = __importDefault(require("relements/build/esm/ui/tabs"));
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var store_1 = __importDefault(require("@src/store"));
var constants_1 = require("../../constants");
require("./SideMenu.scss");
var SideMenu = function (_a) {
    var activeTab = _a.activeTab, handleTabChange = _a.handleTabChange;
    var isGenAiSalesAssistantEnable = store_1["default"].getFeatureFlag(MogamboConstants_1.FEATURE_FLAG_DATA.FLAGS.ENABLE_GEN_AI_SALES_ASSISTANT);
    return (react_1["default"].createElement(tabs_1["default"], { className: "sideMenu", prefixClassName: "sideMenu", value: activeTab }, constants_1.BUSINESS_MANAGER_TABS.map(function (tab) {
        return tab.title === 'Gen AI Sales Assistant' &&
            !isGenAiSalesAssistantEnable ? (react_1["default"].createElement(react_1["default"].Fragment, null)) : (react_1["default"].createElement(tabs_1["default"].Item, { prefixClassName: "sideMenu-tab", key: tab.path, value: tab.path, icon: tab.icon, onClick: handleTabChange }, tab.title));
    })));
};
exports["default"] = SideMenu;
